export default "__VITE_ASSET__3b9d2f20__"